import { render, staticRenderFns } from "./FuncionesGlobales.vue?vue&type=template&id=68b463db&"
import script from "./FuncionesGlobales.vue?vue&type=script&lang=ts&"
export * from "./FuncionesGlobales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('68b463db', component.options)
    } else {
      api.reload('68b463db', component.options)
    }
    module.hot.accept("./FuncionesGlobales.vue?vue&type=template&id=68b463db&", function () {
      api.rerender('68b463db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/FuncionesGlobales/FuncionesGlobales.vue"
export default component.exports